import { ScreenMapping as userScreenMapping } from './userManagement/UserManagementNavigation';
import { ScreenMapping as organizationScreenMapping } from './common/OrganizationManagement';

// Akshat Garg - 2/08/24 - global screens
const screenMappingArr = [
  ...userScreenMapping,
  ...organizationScreenMapping,
];

const screenMap = {};
for (const screen of screenMappingArr) {
  const id = screen.id;
  if (screenMap[id]) {
    throw new Error(`Duplicate key found: ${id}`);
  }
  screenMap[id] = screen;
}

export const globalScreenMapping = screenMap;

export const moduleMenus = {
  user: {
    mapping: userScreenMapping,
  },
  organization: {
    mapping: organizationScreenMapping,
  },
};
